import { render } from "./StockTradeTable.vue?vue&type=template&id=1c6f532a&scoped=true"
import script from "./StockTradeTable.vue?vue&type=script&lang=js"
export * from "./StockTradeTable.vue?vue&type=script&lang=js"

import "./StockTradeTable.vue?vue&type=style&index=0&id=1c6f532a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6f532a"]])

export default __exports__